
import { uuid } from "vue-uuid"
import api from "./api"
import Vue from "vue"
import Router from "vue-router"
import main from "./components/main"
import objects from "./components/cadastral/objects"
// import object from "./components/cadastral/objects/show"
import object from "./components/cadastral/objects/object"
import group from "./components/cadastral/groups/show"
import encoding_rules from "./components/cadastral/groups/encoding_rules"
import analogues from "./components/cadastral/analogues"
import analogues_profitable from "./components/cadastral/analogues_profitable"
import analogue from "./components/cadastral/analogues/show"
// import income_analogues from "./components/cadastral/income_analogues"
import cost_evaluations from "./components/cadastral/cost_evaluations"
import cost_evaluation from "./components/cadastral/cost_evaluations/show"
import statistic from "./components/cadastral/groups/digest"
import expensives from "./components/cadastral/expensive"
import expensive from "./components/cadastral/expensive/show"
import corrections_area_volume from "./components/cadastral/expensive/corrections_area_volume"
import min_age_buildings from "./components/cadastral/expensive/min_age/buildings"
import seismicity_alpha from "./components/cadastral/expensive/seismicity_alpha"
import floor_height_s from "./components/cadastral/expensive/floor_height"
import floor_height from "./components/cadastral/expensive/floor_height/show"
import region_coefs from "./components/cadastral/expensive/region_coefs"
import dev from "./components/dev"

Vue.use(Router)

let router = new Router(
{
	mode : "history",
	routes :
	[
		{
			path : "/",
			name : "first_page",
			beforeEnter : (to, from, next) =>
			{
				next({ name : "main" })
			}
		},
		{
			path : "/dev",
			name : "dev",
			component : dev,
			meta :
			{
				title : "Разработка",
			}
		},
		{
			path : "/files/:url",
			name : "files",
			redirect : to =>
			{
				window.location.href = api.file_url(to.path)
			},
		},
		{
			path : "/objects",
			name : "objects",
			component : objects,
			meta :
			{
				title : "Объекты оценки",
			},
		},
		{
			path : "/objects?query=:query",
			name : "objects_by_query",
			component : objects,
			meta :
			{
				title : "Объекты оценки",
			},
		},
		{
			path : "/objects/:id",
			name : "object",
			component : object,
			meta :
			{
				title : "Объект оценки",
			},
		},
		{
			path : "/objects/cadastral_number/:cadastral_number",
			name : "object_by_cadastral_number",
			component : object,
			meta :
			{
				title : "Объект оценки",
			},
		},
		{
			path : "/groups/:id/:type?",
			name : "group",
			component : group,
			meta :
			{
				title : "Группа",
			},
		},
		{
			path : "/encoding_rules/:id",
			name : "encoding_rules",
			component : encoding_rules,
			meta :
			{
				title : "Кодирование ЦОФ",
			},
		},
		{
			path : "/cost_evaluations",
			name : "cost_evaluations",
			component : cost_evaluations,
			meta :
			{
				title : "Реестр моделей оценки КС",
			}
		},
		{
			path : "/cost_evaluations/:id/:type?",
			name : "cost_evaluation",
			component : cost_evaluation,
			meta :
			{
				title : "Информация о моделях расчета КС",
			},
		},
		{
			path : "/group_statistic/:id",
			name : "group_statistic",
			component : statistic,
			meta :
			{
				title : "Статистика",
			},
		},
		{
			path : "/analogues",
			name : "analogues",
			component : analogues,
			meta :
			{
				//title : "Объекты-аналоги",
				title : "Сравнительный подход",
			}
		},
		{
			path : "/analoguesprofitable",
			name : "analoguesprofitable",
			component : analogues_profitable,
			meta :
			{
				//title : "Объекты-аналоги",
				title : "Доходный подход",
			}
		},
		{
			path : "/analogues/:id",
			name : "analogue",
			component : analogue,
			meta :
			{
				title : "Информация об объекте-аналоге",
			},
		},
		{
			path : "/expensives",
			name : "expensives",
			component : expensives,
			meta :
			{
				title : "Затратный подход (Справочник Укрупненные нормативы цены строительства)",
			}
		},
		{
			path : "/expensives/:id",
			name : "expensive",
			component : expensive,
			meta :
			{
				title : "Информация об объекте-аналоге",
			},
		},
		{
			path : "/corrections_area_volume",
			name : "corrections_area_volume",
			component : corrections_area_volume,
			meta :
			{
				title : "Поправки на площадь и объем",
			},
		},
		{
			path : "/floor_height",
			name : "floor_height_s",
			component : floor_height_s,
			meta :
			{
				title : "Данные для расчета строительного объема",
			}
		},
		{
			path : "/floor_height/:id",
			name : "floor_height",
			component : floor_height,
			meta :
			{
				title : "Информация об этаже",
			},
		},
		{
			path : "/seismicity_alpha",
			name : "seismicity_alpha",
			component : seismicity_alpha,
			meta :
			{
				title : "Справочник сейсмичности",
			},
		},
		{
			path : "/min_age_buildings",
			name : "min_age_buildings",
			component : min_age_buildings,
			meta :
			{
				title : "Срок экономической жизни",
			},
		},
		{
			path : "/region_coefs",
			name : "region_coefs",
			component : region_coefs,
			meta :
			{
				title : "Региональные коэффициенты",
			},
		},
		{
			path : "/main",
			name : "main",
			component : main,
			meta :
			{
				title : "Главная страница",
			}
		},
  ]
})

router.beforeEach(async (to, from, next) => 
{
	var updated = false
	
	const new_procedure = to.query.procedure
	const new_token = to.query.token
	const readonly = to.query.readonly == "1" ? "true" : "false"

	window.localStorage.setItem("readonly", readonly)

	if(new_procedure == null)
		to.query.procedure = window.sessionStorage.getItem("procedure")
	else
	{
		const is_new = window.sessionStorage.getItem("procedure") != new_procedure

		window.sessionStorage.setItem("procedure", new_procedure)

		if(is_new)
		{
			location.reload()
		}
	}

	if(new_token == null)
	{
		to.query.token = window.localStorage.getItem("session")
		await api.load_roles()
	}
	else
	{
		window.localStorage.setItem("session", new_token)
		await api.load_roles(true)
	}

	if(to.query.storage_prefix != null)
		router.storage_prefix = to.query.storage_prefix
	else
	{
		if(router.storage_prefix == null)
			router.storage_prefix = uuid.v1()

		to.query.storage_prefix = router.storage_prefix
		updated = true
	}

	if(updated)
	{
		next(to)

		return
	}

	next()
})

export default router

